'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

NotificationSettingsConfig=class NotificationSettingsConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('notificationSettings');
$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=NotificationSettingsConfig;
//# sourceMappingURL=notificationSettingsConfig.js.map
